import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'app-view-image',
  templateUrl: './view-image.component.html',
  styleUrls: ['./view-image.component.scss']
})
export class ViewImageComponent implements OnInit {
  URL :any
  constructor( public dialogRef: MatDialogRef<ViewImageComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
      console.log('URL',data)
      if (!/^https?:\/\//i.test(data.URL)) {
        this.URL = 'http://' + data.URL;
      }
      console.log('url', this.URL);
     }

  ngOnInit() {
  }

}
